module.exports = __webpack_public_path__ + "static/img/histoire-02.e678db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/histoire-02.png
// module id = 87
// module chunks = 0